'use client'

import { Button } from '@/components/ui/button'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '@/components/ui/carousel'
import { useWordPressPostsQuery } from '@/hooks/react-query/blog/use-wordpress-posts.query'
import { cn } from '@/lib/utils'
import { useTranslations } from 'next-intl'
import Link from 'next/link'
import { NewsItem } from './news-item'

type Props = {
  categoryId: number
  perPage?: number
  isMonthNews?: boolean
}

export const NewsList = ({ categoryId, perPage = 4, isMonthNews }: Props) => {
  const t = useTranslations('landing_coolmate_101_page.news')
  const tButton = useTranslations('button')
  const { data, isLoading } = useWordPressPostsQuery(categoryId, perPage)

  const viewMoreUrl = isMonthNews
    ? 'https://www.coolmate.me/blog/danh-muc/truyen-thong/tap-chi-noi-bo/ban-tin-hang-thang'
    : 'https://www.coolmate.me/blog/danh-muc/truyen-thong/tap-chi-noi-bo/tin-tuc-va-hoat-dong'

  if (isLoading) return <div>{t('loading')}</div>

  return (
    <div
      className={cn(
        '-mx-5 bg-primary px-5 py-6 lg:mx-0 lg:rounded-3xl lg:p-10',
        isMonthNews && 'bg-neutral-50 px-4 py-10 lg:bg-neutral-300'
      )}
    >
      <h3
        className={cn(
          'text-lg font-semibold leading-7 text-light',
          isMonthNews && 'text-neutral-900'
        )}
      >
        {isMonthNews ? t('monthly_news') : t('news_and_activities')}
      </h3>

      {isMonthNews ? (
        <div className='mt-5 grid gap-4.5 lg:grid-cols-2'>
          {data?.map((item) => (
            <NewsItem item={item} key={item._id} isMonthNews />
          ))}
        </div>
      ) : (
        // Mobile: slide 1.2 item/lần, desktop: tắt carousel và hiển thị dạng grid
        <Carousel
          opts={{
            align: 'start',
            breakpoints: { '(min-width: 1024px)': { active: false } },
          }}
          className='mt-5'
        >
          <CarouselContent className='-ml-4.5 lg:ml-0 lg:grid lg:grid-cols-4 lg:gap-4.5'>
            {data?.map((item) => (
              <CarouselItem
                key={item._id}
                className='basis-5/6 cursor-auto pl-4.5 lg:basis-auto lg:pl-0'
              >
                <NewsItem item={item} />
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>
      )}

      <div className='flex justify-center pb-4 pt-6'>
        <Button asChild variant={isMonthNews ? 'black' : 'white'}>
          <Link href={viewMoreUrl} target='_blank' rel='noreferrer noopener'>
            {tButton('view_more')}
          </Link>
        </Button>
      </div>
    </div>
  )
}
